import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// External components
import ModalDishFilters from "@/components/modalDishFilters/modalDishFilters";
import IngredientCard from "@/components/ingredientCard/ingredientCard";
import ModalConfirmationMessage from "@/components/modalConfirmationMessage/modalConfirmationMessage";

// Helpers
import { getEmptyProductImageUrl } from "@/plugins/products_helper";
import { isDeliveryAvailable } from "@/plugins/subscriptions_helper";
import store from "@/store/store";

@Component({
  components: { ModalDishFilters, IngredientCard, ModalConfirmationMessage },
  beforeRouteEnter(to, from, next) {
    if (!isDeliveryAvailable(store.getters.getSubscription)) {
      next({ name: "subscriptionOrdersHome" });
    } else {
      next();
    }
  },
})
export default class SubscriptionIngredients extends Vue {
  @Action action_getIngredients;
  @Action action_updateSubscription;

  @Getter getIngredients;
  @Getter getCity;
  @Getter getSubscription;
  @Getter getIngredientToReplace;
  @Getter getMenus;

  @Mutation SPINNER;

  isShowingModalDishFilters = false;
  isShowingConfirmationMessageModal = false;

  loading = true;

  ingredients = [];
  currentSelectedTags = [];
  currentIngredientInfo = {
    menu_id: null,
    menu_option_id: null,
    count_id: null,
    menu_item_id: null,
  };

  get currentMenu() {
    return this.getMenus.find((menu) => menu.id === this.currentIngredientInfo.menu_id);
  }

  mounted() {
    const { tags } = this.getSubscription;
    const { menu_id, menu_option_id, count_id, menu_item_id } = this.$route.params;

    if (!menu_id || !menu_option_id || !count_id || !menu_item_id) {
      this.$router.replace({ name: "subscriptionNextOrderDetail" });
    } else {
      this.currentIngredientInfo = { menu_id, menu_option_id, count_id, menu_item_id };
    }
    this.currentSelectedTags = JSON.parse(JSON.stringify(tags));
    this.fetchIngredients();
  }

  async fetchIngredients() {
    this.loading = true;
    this.ingredients = [];
    const avoidTags = this.currentSelectedTags.map((tag) => tag.id);
    try {
      const { menu_id, menu_option_id, count_id, menu_item_id } = this.currentIngredientInfo;
      this.ingredients = await this.action_getIngredients({
        commerceId: 3,
        menu_id,
        menu_option_id,
        count_id,
        menu_item_id,
        noInclude: avoidTags,
      });
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al obtener los ingredientes. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.loading = false;
  }

  async changeIngredient(selectedIngredient) {
    const { sub_menu_id, count_id, menu_id } = this.getIngredientToReplace;
    const { menu_items_product_id, menu_option_id } = selectedIngredient;
    const subscriptionMenusAttributes = [
      { id: sub_menu_id, _destroy: true },
      { count_id, menu_id, menu_items_product_id, menu_option_id },
    ];
    try {
      this.SPINNER(true);
      await this.action_updateSubscription({
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: {
          subscription: { subscription_menus_attributes: subscriptionMenusAttributes },
        },
      });
      this.isShowingConfirmationMessageModal = true;
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `No fue posible actualizar el producto. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.SPINNER(false);
  }

  onSetTagsFilter(newTags) {
    this.isShowingModalDishFilters = false;
    this.currentSelectedTags = newTags;
    this.fetchIngredients();
  }

  getIngredientImage(ingredient) {
    const { img } = ingredient;
    if (!img || !img.url) return getEmptyProductImageUrl();
    return img.url;
  }

  onConfirmationModalClose() {
    this.isShowingConfirmationMessageModal = false;
    this.$router.replace({ name: "subscriptionNextOrderDetail" });
  }
}
